import { useUrlSearchParams } from '@vueuse/core';
import { ref } from 'vue';

const isIFrameMode = ref(false);

const params = useUrlSearchParams('hash');
// see if we find the api key in the params
const expectedApiKey = ((window as any).__ENV__ || import.meta.env).VITE_IFRAME_KEY;
const parameterName = 'cockpit_mode';
if (params[parameterName]) {
  const apiKey = params[parameterName];
  // apiKey can either be an array or a string. If it's an array, we'll use the first element, if present, otherwise we'll use the string
  const apiKeyString = Array.isArray(apiKey) ? apiKey[0] : apiKey;
  if (apiKeyString) {
    if (apiKeyString === expectedApiKey) {
      isIFrameMode.value = true;
    } else {
      console.warn('Invalid IFrame key');
    }
  }
}

export const useIFrameMode = () => {
  return {
    isIFrameMode,
  };
};
